// Auto-generated from Electrical Engineering rows in Copy of Staff Academic Particulars_(1).csv
// Registry-only entries were excluded.
// Duplicate Mohammed Katun and Abdulrahman Abdulmalik submissions were consolidated using the later records.
// 36 unique Electrical/Electronics Engineering staff records.

export const ELECTRICAL_STAFF_IMAGE_BASE = "/images/departments/electrical-engineering/staff";

export const electricalEngineeringStaff = [
  {
    id: 1,
    title: "Engr.",
    name: "Alimi Teslim Adekunle",
    rank: "Chief lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/alimi-teslim-adekunle.jpg`,
    qualifications: [
      "ND, HND( FPBida), PGD ELECT(LAUTECH), B.Eng (kwasu),  M.Eng (FUTminna), PhD Elect (inview)"
    ],
    professionalQualifications: [
      "COREN",
      "MNSE",
      "MNI4E",
      "MAIP"
    ],
    publications: "30 Journals, 25 conferences",
    researchInterests: [
      "Optima Load Flow control in power system Network",
      "Power loss reduction in transmission network"
    ],
    specialties: [
      "ND Electrical Engineering, HND Power and Machine,  B.Eng Elect/Elect,",
      "M.Eng power system Engineering,",
      "PhD (Inview)"
    ],
    awards: [],
    email: "alimi.teslim@fedpolybida.edu.ng",
    phone: "08036374037",
    driveFileId: "1ae5Wh6_KBSQ7pHJAt6H-uYy6r0xJFHl2",
    slug: "alimi-teslim-adekunle",
  },
  {
    id: 2,
    title: "Engr.",
    name: "Ahmed Ibrahim Haruna",
    rank: "Lecturer III",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/ahmed-ibrahim-haruna.jpg`,
    qualifications: [
      "B Eng, M Eng (FUT Minna)"
    ],
    professionalQualifications: [
      "MNSE",
      "MNIEEE",
      "COREN"
    ],
    publications: "1",
    researchInterests: [
      "Power Systems, Renewable Energy and Distributed Generation",
      "Renewable Energy",
      "Distributed Generation",
      "Power Distribution Systems",
      "Energy Economics",
      "Home Automation Systems"
    ],
    specialties: [
      "B.Eng (Electrical and Electronics Engineering)",
      "M.Eng (Power Systems)"
    ],
    awards: [],
    email: "Ahmed.ibrahim@fedpolybida.edu.ng",
    phone: "08060831461",
    driveFileId: "1Ra6u2wv6vdEZ4t-XsSUoJDTGG3-pOBTe",
    slug: "ahmed-ibrahim-haruna",
  },
  {
    id: 3,
    title: "Engr. Dr.",
    name: "Mohammed Mahmood Katun",
    rank: "Senior Lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mohammed-mahmood-katun.jpg`,
    qualifications: [
      "B.Eng (FUT), PGDE(UDUS), M.Eng(FUT), PhD(Wits)"
    ],
    professionalQualifications: [
      "MNSE",
      "COREN"
    ],
    publications: "",
    researchInterests: [
      "Power Transformer Insulation",
      "Nanotechnology",
      "West Management and Environment (Mining Tailings Application and Earth Enhancing Compound)",
      "Energy Forecasting Models and Algorithm"
    ],
    specialties: [
      "B.Eng, Electrical and Computer Engineering",
      "M.Eng, Electrical Power and Machines",
      "PhD, Power Transformer Insulation and Nanotechnology"
    ],
    awards: [],
    email: "mahmud.katun@fedpolybida.edu.ng",
    phone: "07031020033",
    driveFileId: "120lqoH_cyD9NxmpbhsSq6995nQFFyPxx",
    slug: "mohammed-mahmood-katun",
  },
  {
    id: 4,
    title: "Engr.",
    name: "Titiloye Stephen Oyediran",
    rank: "Chief Lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/titiloye-stephen-oyediran.jpg`,
    qualifications: [
      "M. Eng (UTM Malaysia"
    ],
    professionalQualifications: [
      "MNSE",
      "COREN"
    ],
    publications: "20 Conferences, 16 Journals",
    researchInterests: [
      "Communications Engineering",
      "Digital Electronics",
      "Electrical Circuit Theory",
      "Control Engineering"
    ],
    specialties: [
      "B. Eng (Electrical Engineering)",
      "M. Eng (Electronics & Communication"
    ],
    awards: [],
    email: "stevetitiloye@fedpolybida.edu.ng",
    phone: "08036184470",
    driveFileId: "1nzNjgk2kpusqDKzLtCs2ys6zQPDuohIe",
    slug: "titiloye-stephen-oyediran",
  },
  {
    id: 5,
    title: "Engr.",
    name: "Shehu Yakubu",
    rank: "Assistant Chief Technologist",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/shehu-yakubu.jpg`,
    qualifications: [
      "ND, HND (FPB), B'ENGR. (FUT MINNA), MASTERS IN RENEWABLE ENERGY (ABU ZARIA)"
    ],
    professionalQualifications: [
      "AIP",
      "NATE",
      "COREN TECH",
      "COREN",
      "NSE"
    ],
    publications: "",
    researchInterests: [
      "Renewable Energy",
      "power system engineering",
      "power system stability",
      "Embedded systems",
      "Energy management",
      "Signals and Systems",
      "power system communication and control",
      "High Voltage Engineering",
      "Electrical Installation",
      "Software Application"
    ],
    specialties: [
      "B'Eng (Energy Management)",
      "MRE (Renewable energy)"
    ],
    awards: [],
    email: "shehuyakubu@fedpolybida.edu.ng",
    phone: "08036545285",
    driveFileId: "14D9FGEC4Hs7P_ppxKGRhkazcUXP8rOJo",
    slug: "shehu-yakubu",
  },
  {
    id: 6,
    title: "Engr.",
    name: "Muhammad Shafii Umar",
    rank: "Assistant Lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/muhammad-shafii-umar.jpg`,
    qualifications: [
      "Bsc(sudan international university)"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [
      "Power & energy",
      "Electronics and devices",
      "Telecommunications and signal",
      "Control and automation",
      "Computer and software"
    ],
    specialties: [
      "Electrical engineering Control system"
    ],
    awards: [],
    email: "SIU-educ.com",
    phone: "08067603057",
    driveFileId: "15LLeYkc8DmiEkdEFTfMyBxhu6kVo9u2D",
    slug: "muhammad-shafii-umar",
  },
  {
    id: 7,
    title: "Engr. Tech.",
    name: "Ibrahim Muhammad Tako",
    rank: "Assistant Chief Technologist",
    image: "/images/default-staff.jpg",
    qualifications: [
      "Bsc"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "Project works",
    researchInterests: [
      "Photovoltaic facade system",
      "Transformer",
      "Energy Theft protection"
    ],
    specialties: [
      "B.eng(Electrical Engineering)",
      "Power System",
      "Electrical power system"
    ],
    awards: [],
    email: "Ibrahimtako@fedpolybida.edu.ng",
    phone: "07033396018",
    driveFileId: "1kxkKeye30nRcsZTRIxqOvakOSjS6gZVa",
    slug: "ibrahim-muhammad-tako",
  },
  {
    id: 8,
    title: "Mr.",
    name: "Mohammed Umar Sani",
    rank: "Senior Instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mohammed-umar-sani.jpg`,
    qualifications: [
      "ND, HND The Federal Polytechnic Bida"
    ],
    professionalQualifications: [
      "NSE"
    ],
    publications: "1",
    researchInterests: [
      "Electronics and Telecommunications",
      "Renewable Energy",
      "Programming"
    ],
    specialties: [
      "HND Electrical and Electronics Engineering"
    ],
    awards: [],
    email: "UmarSaniMohammed@fedpolybida.efu.ng",
    phone: "08039468088",
    driveFileId: "1wLeACYpuu9-nGpOdFm-KjbVgNshZHhqf",
    slug: "mohammed-umar-sani",
  },
  {
    id: 9,
    title: "Engr.",
    name: "Yetunde Titiloye Adebimpe",
    rank: "Chief instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/yetunde-titiloye-adebimpe.jpg`,
    qualifications: [
      "Beng,Fut ,MSC"
    ],
    professionalQualifications: [
      "MNSE",
      "COREN"
    ],
    publications: "15 conference, 15 journals",
    researchInterests: [
      "electronic",
      "computer",
      "security"
    ],
    specialties: [
      "Electrical engineering",
      "Computer engineering"
    ],
    awards: [],
    email: "ytitiloye53@gmail.com",
    phone: "08036368109",
    driveFileId: "15iuc6VtUU6L_V2JwVlQQ7Vf8n6WKneKM",
    slug: "yetunde-titiloye-adebimpe",
  },
  {
    id: 10,
    title: "Mr.",
    name: "Olatidoye I. Ajiboye",
    rank: "Assistance Chief Instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/olatidoye-i-ajiboye.jpg`,
    qualifications: [
      "HND, PGD, BSc"
    ],
    professionalQualifications: [
      "NIEEE"
    ],
    publications: "",
    researchInterests: [
      "Embedded Systems",
      "Automation Systems"
    ],
    specialties: [
      "HND (Electrical Engineering), BSc (Computer Engineering)"
    ],
    awards: [],
    email: "ajiboye.ishola@fedpolybida.edu.ng",
    phone: "08037164997",
    driveFileId: "1HE-euxjt0YQfGn2MfYs4Wq632f6i_i5P",
    slug: "olatidoye-i-ajiboye",
  },
  {
    id: 11,
    title: "Engr.",
    name: "Abdullahi Abubakar",
    rank: "Technician",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/abdullahi-abubakar.jpg`,
    qualifications: [
      "ND"
    ],
    professionalQualifications: [],
    publications: "B,EG",
    researchInterests: [
      "Machine and power",
      "Machine"
    ],
    specialties: [
      "Electrical Engineering, Electronic"
    ],
    awards: [],
    email: "Name@federalpolybida.edu.ng",
    phone: "07063587106",
    driveFileId: "16dc4OhMGEPTDgysA6UJ66zETPbDyFAk5",
    slug: "abdullahi-abubakar",
  },
  {
    id: 12,
    title: "Engr.",
    name: "Abdullahi Alhaji Baba",
    rank: "Senior Lecturer",
    image: "/images/default-staff.jpg",
    qualifications: [
      "Ph d in view, M.tech, B.tech, B.engr."
    ],
    professionalQualifications: [
      "TRCN",
      "NATE. NIEEE",
      "NSE and TEPAN"
    ],
    publications: "39",
    researchInterests: [
      "Telecommunication",
      "Electronics",
      "Survey Research",
      "Entrepreneur in Electrical Engineering",
      "Artificial intelligence"
    ],
    specialties: [
      "B engr. B.tech in Electrical Electronics",
      "Ph.d in Industrial Technology in view"
    ],
    awards: [
      "Best student in Technical/Engineering Student, third Best graduating student ITE 2005 Graduate e. t c"
    ],
    email: "babaabdullahi95@gmail.com",
    phone: "08037570493/07058286638",
    driveFileId: "1_BmmWqDBR1SDR8__-RCYHqInsJrB5w0q",
    slug: "abdullahi-alhaji-baba",
  },
  {
    id: 13,
    title: "Engr.",
    name: "Samuel Mika Ibrahim",
    rank: "Lecturer III",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/samuel-mika-ibrahim.jpg`,
    qualifications: [
      "B.Eng,(ATBU Bauchi),Msc(NDA Post Graduate School))"
    ],
    professionalQualifications: [
      "Coren",
      "Mnse",
      "MniEEE"
    ],
    publications: "16",
    researchInterests: [
      "Communication",
      "Electronics"
    ],
    specialties: [
      "B.Eng (Electrical Engineering",
      "Msc( Communication and Electronics)"
    ],
    awards: [],
    email: "samuel .mika@fedpolybida.edu.ng",
    phone: "08133839957",
    driveFileId: "16cPQ6Qd4rVb2OF3igtnektFbG1c88cTf",
    slug: "samuel-mika-ibrahim",
  },
  {
    id: 14,
    title: "Engr.",
    name: "Rasheedat Abdulmajeed",
    rank: "TECHNOLOGIST 2.",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND( FEDERAL POLYTECHNIC BIDA),   B.Eng ( KWARA STATE UNIVERSITY MALETE, KWARA STATE)"
    ],
    professionalQualifications: [
      "NSE"
    ],
    publications: "NONE.",
    researchInterests: [
      "ELECTRICAL/ELECTRONICS.",
      "TELECOMMUNICATIONS.",
      "CONTROL AND INSTRUMENTATION."
    ],
    specialties: [
      "HND ( ELECTRONICS & TELECOMMUNICATIONS",
      "B.Eng (ELECTRICAL/ELECTRONICS ENGINEERING",
      "M.Eng ( CONTROL & INSTRUMENTATION - IN VIEW)."
    ],
    awards: [],
    email: "FEDERAL POLYTECHNIC BIDA @fedpolybida.edu.ng",
    phone: "08165412283",
    driveFileId: "1sPoKNIr7rWz9UDEH5gQzj8bRxkcPP8Et",
    slug: "rasheedat-abdulmajeed",
  },
  {
    id: 15,
    title: "Tgst.",
    name: "Aliyu Mohammed Haruna",
    rank: "TECHNOLOGIST I",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND ELECTRICAL ENGINEERING"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "10",
    researchInterests: [
      "Electric Field",
      "Electrical outlet and Machine",
      "Electrical Power",
      "Electrical Installation"
    ],
    specialties: [
      "Electrical Installation Engineering",
      "Electrical Engineering"
    ],
    awards: [],
    email: "harunamuhammadmagnet@gmail.com",
    phone: "08036842011",
    driveFileId: "1KqABYzXz9L3oKuDvH_tNYxhzWqCkQ6aJ",
    slug: "aliyu-mohammed-haruna",
  },
  {
    id: 16,
    title: "",
    name: "Muhammad B. Saleh",
    rank: "Technician",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/muhammad-b-saleh.jpg`,
    qualifications: [
      "ND"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [],
    specialties: [],
    awards: [],
    email: "muhdbsaleh@gmail.com",
    phone: "07061176104",
    driveFileId: "13m_rnTzSbjwNKOlT1HNMfngCzCsgI-A8",
    slug: "muhammad-b-saleh",
  },
  {
    id: 17,
    title: "",
    name: "Abubakar Mohammed Baba",
    rank: "ASSISTANT CHIEF INSTRUCTOR",
    image: "/images/default-staff.jpg",
    qualifications: [
      "B. ENG FUT, M. ENG FUT, PhD in view"
    ],
    professionalQualifications: [
      "MNSE"
    ],
    publications: "5",
    researchInterests: [
      "RADIO FREQUENCY ENERGY HARVESTER",
      "ENERGY EFFICIENT CLUSTER BASE DATA AGGREGATION FRAME FOR PROLONGING THE NETWORK LIFE TIME"
    ],
    specialties: [
      "Communication Engineering"
    ],
    awards: [],
    email: "abijid003@gmail.com",
    phone: "09033275769",
    driveFileId: "1HhMIxPr1zPio_g3YAIR-A2PpYAHZ2RbN",
    slug: "abubakar-mohammed-baba",
  },
  {
    id: 18,
    title: "Engr.",
    name: "Christian Onu",
    rank: "Assistant Chief Instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/christian-onu.jpg`,
    qualifications: [
      "ND (FPBida), HND (FPBida), PGD (ABU Zaria), BEng (FUT Minna), MEng (FUT Minna), PhD (in view) (KWASU Malete)"
    ],
    professionalQualifications: [
      "COREN",
      "MNSE",
      "MNI4E",
      "MAIP"
    ],
    publications: "16 Journal, 22 Conferences",
    researchInterests: [
      "Heterogenous Network ( QoS, Interference, Throughput)",
      "Renewable Energy",
      "Machine Learning/Artificial intelligence"
    ],
    specialties: [
      "ND Electrical Engineering, HND Electronics and Telecommunications Engineering, BEng Electrical and Electronics Engineering",
      "MEng Communication Engineering",
      "PhD Electrical and Electronics Engineering (Communication option)"
    ],
    awards: [],
    email: "onu.christian@.fedpolybida.edu.ng",
    phone: "07036666853",
    driveFileId: "1scJx1HtOJjE2B28pFgrWgx96HwELwIHa",
    slug: "christian-onu",
  },
  {
    id: 19,
    title: "Engr.",
    name: "Abdullahi A. Jibrin",
    rank: "Principal Technologist.",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/abdullahi-a-jibrin.jpg`,
    qualifications: [
      "B.Eng (FUT Minna)."
    ],
    professionalQualifications: [
      "NATE",
      "NAIP"
    ],
    publications: "",
    researchInterests: [
      "Design and Construction of a Energy Saving System.",
      "Design and Implementation of a GSM based Fire Alarm System.",
      "Design and Construction of a Wireless Patient to Doctors Notification System with GSM Alert.",
      "Sensors Network"
    ],
    specialties: [
      "B.Eng (Electrical and Electronics Engineering)"
    ],
    awards: [],
    email: "abdullahijibrin1575@gmail.com",
    phone: "08060928909.",
    driveFileId: "1N_Pc5pBaYpQU8Bcya0EKD3u4XzTHgoc0",
    slug: "abdullahi-a-jibrin",
  },
  {
    id: 20,
    title: "Engr.",
    name: "Ibrahim Umaru",
    rank: "Chief lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/ibrahim-umaru.jpg`,
    qualifications: [
      "B.Eng.(FUT Minna), M.Eng. (BUK Kano),"
    ],
    professionalQualifications: [
      "MNSE",
      "NIEEE",
      "COREN"
    ],
    publications: "15",
    researchInterests: [
      "Electrical control and Intrumentation",
      "Process Control Engineering",
      "Instrumentation and measurement"
    ],
    specialties: [
      "B.Eng.( Electrical and Computer Engineering",
      "M.Eng. (Electrical Control and Instrumentation)",
      "Process control"
    ],
    awards: [],
    email: "Ibrahim.Umar@fedpolybida.edu.ng",
    phone: "08039711189",
    driveFileId: "1sbIVELUhAX7i6Anx4DDxWoWNCCp2qKvv",
    slug: "ibrahim-umaru",
  },
  {
    id: 21,
    title: "Engr.",
    name: "Bala Abubakar",
    rank: "Chief Instructor, Applied for Principal Lecture",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/bala-abubakar.jpg`,
    qualifications: [
      "HND (FED. POLY, BAUCHI), Bsc (FUT, MINNA), MSc (ABU, ZARIA)"
    ],
    professionalQualifications: [
      "NATE",
      "COREN"
    ],
    publications: "",
    researchInterests: [
      "Electrical Power and Machines"
    ],
    specialties: [
      "B.Eng (Elect/Elect), M.Sc (Power and Machines)"
    ],
    awards: [],
    email: "Abubakar.Bala@fedpolybida.edu.ng",
    phone: "08067463586",
    driveFileId: "1FbnBx-km3gFp84jLrAkq_bPCRc-9sXKw",
    slug: "bala-abubakar",
  },
  {
    id: 22,
    title: "Engr.",
    name: "Idris Nda",
    rank: "ASSISTANT CHIEF TECHNOLOGIST",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "",
    researchInterests: [
      "RF ENERGY HARVESTER"
    ],
    specialties: [
      "POWER AND MACHINE"
    ],
    awards: [],
    email: "ndaidris@gmail.com",
    phone: "08060158118",
    driveFileId: "1A1oHSh6k8FCMBoSuBryO890skefnz1Ud",
    slug: "idris-nda",
  },
  {
    id: 23,
    title: "Engr.",
    name: "Mohammed S. Abubakar",
    rank: "Senior Technologies",
    image: "/images/default-staff.jpg",
    qualifications: [
      "B. Eng (FUT Minna)."
    ],
    professionalQualifications: [
      "MNSE"
    ],
    publications: "",
    researchInterests: [
      "Design and Construction of a Home Automation.",
      "Design and Construction of a Burglary Alarm System."
    ],
    specialties: [
      "B. Eng (Power and Machine)"
    ],
    awards: [],
    email: "abubakar7316@gmail.com",
    phone: "08062412829",
    driveFileId: "1GPipu6Sxs8oFsWnDZoD6Z3yoX26S9lWh",
    slug: "mohammed-s-abubakar",
  },
  {
    id: 24,
    title: "Mr.",
    name: "Mahmudu Saidu Minin",
    rank: "ASSISTANT TECHNICIAN",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mahmudu-saidu-minin.jpg`,
    qualifications: [
      "National diploma"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [],
    specialties: [
      "ELECTRICAL ELECTRONIC"
    ],
    awards: [],
    email: "mksaidu2015@gmail.com",
    phone: "07068843945",
    driveFileId: "1hwYtdVDRiQePYJRdsiVDTXs6TgXc2XKA",
    slug: "mahmudu-saidu-minin",
  },
  {
    id: 25,
    title: "Engr.",
    name: "Ibrahim Alh. Jibrin",
    rank: "Senior Laboratory Assistant.",
    image: "/images/default-staff.jpg",
    qualifications: [
      "Diploma ( ABU Zaria)"
    ],
    professionalQualifications: [
      "NAIP"
    ],
    publications: "",
    researchInterests: [
      "Integrated Science.",
      "Basic Electronics Equipments"
    ],
    specialties: [
      "Diploma (Integrated Science Engineering)"
    ],
    awards: [],
    email: "talk2alhajijibrin@gmail.com",
    phone: "08068",
    driveFileId: "1rw8TQycf9dm1mYNExyCKJbmUxsSDbc0j",
    slug: "ibrahim-alh-jibrin",
  },
  {
    id: 26,
    title: "Mr.",
    name: "Mohammed Umar",
    rank: "Technician",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mohammed-umar.jpg`,
    qualifications: [
      "National Diploma"
    ],
    professionalQualifications: [
      "Nate"
    ],
    publications: "ND",
    researchInterests: [],
    specialties: [
      "Electrical Installation"
    ],
    awards: [],
    email: "Mohammed umar7938@gmail.com",
    phone: "08068009141",
    driveFileId: "1K35ad_7fNC6HYCou9TnLx2imuSHV1drk",
    slug: "mohammed-umar",
  },
  {
    id: 27,
    title: "Engr.",
    name: "Abbas Alhaji Katun",
    rank: "PRINCIPLE TECHNICIAN II",
    image: "/images/default-staff.jpg",
    qualifications: [
      "CERTIFICATE IN LOCAL GOVERNMENT"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "",
    researchInterests: [
      "Administrative"
    ],
    specialties: [
      "ENERGY"
    ],
    awards: [],
    email: "alhajiabbaskayun@gmail.com",
    phone: "09053493096",
    driveFileId: "16fj00IthhtVnaP2eBoTwrqS_h-3ebRQt",
    slug: "abbas-alhaji-katun",
  },
  {
    id: 28,
    title: "Engr.",
    name: "Yusuf Jibrin",
    rank: "PRINCIPAL TECHNICIAN II",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "",
    researchInterests: [
      "ENERGY"
    ],
    specialties: [
      "ELECTRICAL"
    ],
    awards: [],
    email: "jibrinyusuf871@gmail.com",
    phone: "08074538047",
    driveFileId: "1JwvAX0l0vtNXzphxkPOkRop7b5P4F2vT",
    slug: "yusuf-jibrin",
  },
  {
    id: 29,
    title: "",
    name: "Abdulrahman Abdullahi",
    rank: "TECHNOLOGY 1",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND ELECTRICAL ELECTRONIC"
    ],
    professionalQualifications: [
      "NATE"
    ],
    publications: "",
    researchInterests: [],
    specialties: [
      "POWER MACHINE"
    ],
    awards: [],
    email: "abdulrahman.abdullahi@fedpolybida.edu.ng",
    phone: "07061690713",
    driveFileId: "1BoOYwkZSYnSqdhqaTnucEWSZ_Z73Jh6s",
    slug: "abdulrahman-abdullahi",
  },
  {
    id: 30,
    title: "Engr.",
    name: "Mohammed Katun",
    rank: "Lecturer 1",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mohammed-katun.jpg`,
    qualifications: [
      "B. Tech (FUT Minna) , PGd. Electrical power (AFIT. Kaduna )"
    ],
    professionalQualifications: [
      "COREN"
    ],
    publications: "6",
    researchInterests: [
      "Power Systems Analysis",
      "Power electronic",
      "Renewable energy",
      "protection and relay",
      "Power Systems and control",
      "Power and Machine",
      "Reliability"
    ],
    specialties: [
      "B. Engr. (Electrical power Engineering)",
      "M.Engr. (power and Machine) option Engineering"
    ],
    awards: [],
    email: "mohammed.katun@fedpolybida.edu.ng",
    phone: "08065784042",
    driveFileId: "1enp8n5gpSedb7ySVuj5UVo54IxhEtVJU",
    slug: "mohammed-katun",
  },
  {
    id: 31,
    title: "Mr.",
    name: "Abdurahman Yahaya Fusamu",
    rank: "TECHNOLOGY 3",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [],
    specialties: [
      "POWER MACHINE"
    ],
    awards: [],
    email: "Fusamua@mil.com",
    phone: "07068803155",
    driveFileId: "1PSFJ1SZMkbfV03Rsjt92Clwpm3IBguIJ",
    slug: "abdurahman-yahaya-fusamu",
  },
  {
    id: 32,
    title: "Mr.",
    name: "Yusuf Isah Isah",
    rank: "Technologist 1",
    image: "/images/default-staff.jpg",
    qualifications: [
      "HND (KAD POLY)"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [
      "Tellecomm",
      "Power communication",
      "Renewable energy",
      "Electronics Communication"
    ],
    specialties: [
      "B. Eng"
    ],
    awards: [],
    email: "fedpolybida.edu.ng",
    phone: "07061348636",
    driveFileId: "1C-wTlC86M1DNRSHgJoc0cLNEhK-qKI3H",
    slug: "yusuf-isah-isah",
  },
  {
    id: 33,
    title: "Mr.",
    name: "Abdulrahman Abdulmalik",
    rank: "Higher instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/abdulrahman-abdulmalik.jpg`,
    qualifications: [
      "B. Eng"
    ],
    professionalQualifications: [],
    publications: "",
    researchInterests: [
      "Power"
    ],
    specialties: [
      "B. Eng (Electrical Engineering)",
      "Msc (in view)"
    ],
    awards: [],
    email: "abdulrahman.abdulmalik@fedpolybida.edu.ng",
    phone: "07067314074",
    driveFileId: "1NoaEM0fYKyMYdrcTORuokCjZ7yjILITN",
    slug: "abdulrahman-abdulmalik",
  },
  {
    id: 34,
    title: "Engr.",
    name: "Sulaiman Alhaji Man",
    rank: "Chief Instructor",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/sulaiman-alhaji-man.jpg`,
    qualifications: [
      "HND (Fed.Poly Nasarawa), Beng (Kwasu), Msc (Nile, Abuja)"
    ],
    professionalQualifications: [
      "AIP",
      "NATE",
      "MNSE",
      "COREN"
    ],
    publications: "3",
    researchInterests: [
      "Power source Availability as a Means of Reducing Agricultural Post Havest losses",
      "Design and Retrofitting of a 200 litres Solar Power Frezer",
      "An Appraisal of Solar Power Water system for Sustainable Rural Development"
    ],
    specialties: [
      "Beng (Electrical and electronics engineering)",
      "Msc (power option)"
    ],
    awards: [],
    email: "sulaimanman@fedpolybida.edu.ng",
    phone: "08036218828",
    driveFileId: "1ZtPAo69Z9axKu0yj5Da0Jx6_69tGdvRK",
    slug: "sulaiman-alhaji-man",
  },
  {
    id: 35,
    title: "Engr.",
    name: "Raheem Azeez Olalekan",
    rank: "Chief  Lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/raheem-azeez-olalekan.jpg`,
    qualifications: [
      "B.Eng (ABU zaria) M.Sc (ABU zaria)"
    ],
    professionalQualifications: [
      "MNSE. COREN"
    ],
    publications: "Two",
    researchInterests: [
      "Telecommunication",
      "Radi Frequently Energy Harvesting"
    ],
    specialties: [
      "B.Eng (Electrical Engineering/",
      "M.Sc (Electrical Engineering)"
    ],
    awards: [],
    email: "raheem.azeez@fedpolybida.edu.ng",
    phone: "07032204988",
    driveFileId: "1JV2Gri_WHrCzmOkyyd1VVZE74kyqCwRA",
    slug: "raheem-azeez-olalekan",
  },
  {
    id: 36,
    title: "Engr.",
    name: "Mohammed Mahmud Sulaiman",
    rank: "Senior Lecturer",
    image: `${ELECTRICAL_STAFF_IMAGE_BASE}/mohammed-mahmud-sulaiman.jpg`,
    qualifications: [
      "BEng. (ABU Zaria), MEng. (Unilorin)"
    ],
    professionalQualifications: [
      "MNSE",
      "COREN"
    ],
    publications: "",
    researchInterests: [
      "Digital Signal Processing",
      "Artificial Intelligence"
    ],
    specialties: [
      "B.Eng (Electrical Engineering)",
      "M.Eng (Computer Engineering)"
    ],
    awards: [],
    email: "suleiman.mahmud@fedpolybida.edu.ng",
    phone: "08036218255",
    driveFileId: "1j77S-20yvh3wjLWVjvlNYEgGTy9QoG6N",
    slug: "mohammed-mahmud-sulaiman",
  }
];

export default electricalEngineeringStaff;
